import {Group} from 'src/design/atoms/Group';
import {Text} from 'src/design/atoms/Text';
import {Tooltip} from 'src/design/atoms/Tooltip';
import type {FC} from 'react';
import type {InspectionScheduleResponse} from 'src/api/ProactApiClient';
import {Pill} from 'src/design/atoms/Pill';
import {scheduleHealthPills} from './inspectionScheduleHelpers';

export interface ScheduleHealthPillsProps {
  schedule: InspectionScheduleResponse;
  /** Rendered when the schedule has no configuration issues. */
  emptyText?: string;
}

/**
 * Configuration-issue pills for one schedule, each with its consequence tooltip.
 * @registry Health pills for an inspection recurrence schedule.
 */
export const ScheduleHealthPills: FC<ScheduleHealthPillsProps> = ({
  schedule,
  emptyText,
}) => {
  const items = scheduleHealthPills(schedule);

  if (items.length === 0) {
    return emptyText ? (
      <Text size="sm" c="dimmed">
        {emptyText}
      </Text>
    ) : null;
  }

  return (
    <Group gap={4} wrap="wrap">
      {items.map(({pill, tooltip}) =>
        tooltip ? (
          <Tooltip key={pill.text} label={tooltip} withArrow multiline w={240}>
            <span>
              <Pill {...pill} />
            </span>
          </Tooltip>
        ) : (
          <Pill key={pill.text} {...pill} />
        )
      )}
    </Group>
  );
};
